const INITIAL_STATE = {
  inputData: [],
};

const SystemReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'setCollegueInputDataAction':
      return { ...state, inputData: action.payload };
    case 'addCollegueInputDataAction':
      return {
        ...state,
        inputData: [...state.inputData, ...action.payload],
      };

    default:
      return state;
  }
};

export default SystemReducer;
